import constants from "../constants";
import Dashboard from "../pages/Dashboard";
import ForgotPassword from "../pages/ForgotPassword";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Welcome from "../pages/Welcome";
import Logout from "../pages/Logout";
import Profile from "../pages/Profile";
import Users from "../pages/Users";
import NotFound from "../pages/NotFound";
import ResetPassword from "../pages/ResetPassword";
import RouteGuard from "../RouteGuard";
import { schoolResource } from "./resources";
import Sessions from "../pages/Sessions";
import Faculty from "../pages/Faculty";
import Department from "../pages/Department";
import Role from "../pages/Role";
import LevelGrade from "../pages/LevelGrade";
import Class from "../pages/Class";


export const routes = [
  {
    path: constants.routes.home,
    name: "HOME",
    exact: true,
    component: Home
  },
  {
    path: constants.routes.login,
    name: "LOGIN",
    exact: true,
    component: Login
  },
  {
    path: constants.routes.forgotpassword,
    name: "FORGOT PASSWORD",
    exact: true,
    component: ForgotPassword
  },
  {
    path: constants.routes.resetpassword,
    name: "RESET PASSWORD",
    exact: true,
    component: RouteGuard(ResetPassword)
  },
  {
    path: constants.routes.welcome,
    name: "WELCOME",
    exact: true,
    component: RouteGuard(Welcome)
  },
  {
    path: constants.routes.profile,
    name: "PROFILE",
    exact: true,
    component: RouteGuard(Profile),
    resources: [schoolResource]
  },
  {
    path: constants.routes.users,
    name: "USERS",
    exact: true,
    component: RouteGuard(Users),
    resources: [schoolResource]
  },
  {
    path: constants.routes.dashboard,
    name: "DASHBOARD",
    exact: true,
    component: RouteGuard(Dashboard),
    resources: [schoolResource]
  },
  {
    path: constants.routes.sessions,
    name: "SESSIONS",
    exact: true,
    component: RouteGuard(Sessions),
    resources: [schoolResource]
  },
  {
    path: constants.routes.faculty,
    name: "FACULTY",
    exact: true,
    component: RouteGuard(Faculty),
    resources: [schoolResource]
  },  
  {
    path: constants.routes.department,
    name: "DEPARTMENT",
    exact: true,
    component: RouteGuard(Department),
    resources: [schoolResource]
  },
  {
    path: constants.routes.levelGrade,
    name: "LEVEl GRADE",
    exact: true,
    component: RouteGuard(LevelGrade),
    resources: [schoolResource]
  },
  {
    path: constants.routes.class,
    name: "CLASS",
    exact: true,
    component: RouteGuard(Class),
    resources: [schoolResource]
  },
  {
    path: constants.routes.role,
    name: "ROLE",
    exact: true,
    component: RouteGuard(Role),
    resources: [schoolResource]
  },
  {
    path: constants.routes.logout,
    name: "LOGOUT",
    exact: true,
    component: RouteGuard(Logout)
  },
  {
    path: "*",
    name: "NOT_FOUND",
    component: NotFound
  }
];
